import styled from 'styled-components';

export const StyledToastContainer = styled.div`
  transform: translate(-50%);
  left: 50%;
  bottom: ${(p) => p.theme.space[0]};
  z-index: 2;
  position: fixed;
  max-width: 480px;
`;
